<template>
  <proa-card>
    <proa-list-group>
      <proa-list-group-item
        v-for="groupChat in groupChats"
        :key="groupChat.id"
        :class="['group-chat-container', { 'active': activeGroupChatId == groupChat.id }]"
        @mouseover.native="onMouseOverGroupChat(groupChat.id)"
        @mouseleave.native="onMouseLeaveGroupChat"
        @click.native="$emit('onClickGroupChat', groupChat.id)"
      >
        <div class="title">
          <proa-badge :value="groupChat.unreadCount" v-if="groupChat.unreadCount" class="title-badge"/>
          {{ groupChat.groupChatName }}
        </div>
        <div class="message">{{ groupChat.message }}</div>
        <div class="recent-post-at">
          <span>{{ groupChat.recentPostAt | momentDiff() }}</span>
        </div>
        <div>
          <!-- TODO: 会議予約 -->
          <!-- <proa-button
            @mouseover.native.stop="activeGroupChatId = null"
          >
            {{ $t('common.meetingReservation') }}
          </proa-button> -->
        </div>
        <div
          class="d-none d-md-block"
          :class="['information', { 'active': activeGroupChatInformationId == groupChat.id }]"
          @mouseover.stop="onMouseOverGroupChatInformation(groupChat.id)"
          @mouseleave.stop="onMouseLeaveGroupChatInformation()"
          @click.stop="$emit('onClickGroupChatInformation', groupChat.id)"
        >
          <img :src="require('@/assets/images/icons/information.png')" />
        </div>
        <div
          class="d-none d-md-block"
          :class="['user', { 'active': activeGroupChatUsersId == groupChat.id }]"
          @mouseover.stop="onMouseOverGroupChatUsers(groupChat.id)"
          @mouseleave.stop="onMouseLeaveGroupChatUsers()"
          @click.stop="$emit('onClickGroupChatUsers', groupChat.id)"
        >
          <img :src="require('@/assets/images/icons/user.png')" />
        </div>
      </proa-list-group-item>
    </proa-list-group>
  </proa-card>
</template>

<script>
export default {
  name: 'groupChatsCard',
  props: {
    groupChats: Array
  },
  data() {
    return {
      activeGroupChatId: null,
      activeGroupChatInformationId: null,
      activeGroupChatUsersId: null
    }
  },
  methods: {
    onMouseOverGroupChat: function(id) {
      this.activeGroupChatId = id
    },
    onMouseLeaveGroupChat: function() {
      this.activeGroupChatId = null
    },
    onMouseOverGroupChatInformation: function(id) {
      this.activeGroupChatId = null
      this.activeGroupChatInformationId = id
    },
    onMouseLeaveGroupChatInformation: function() {
      this.activeGroupChatInformationId = null
    },
    onMouseOverGroupChatUsers: function(id) {
      this.activeGroupChatId = null
      this.activeGroupChatUsersId = id
    },
    onMouseLeaveGroupChatUsers: function() {
      this.activeGroupChatUsersId = null
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.group-chat-container {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.active {
    background-color: $light-gray-color;
  }

  .title {
    flex-shrink: 0;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 25%;

    .title-badge {
      position: relative;
      bottom: 1.5px;
      margin-right: 10px;
    }
  }

  .recent-post-at {
    color: $light-text-color;
    font-size: 11px;
    white-space: nowrap;
    margin: 0 0 0 45px;

    @include mq(md) {
      margin: 0 40px 0 10px;
    }
  }

  .information, .user {
    cursor: pointer;
    width: 26px;
    height: 26px;
    padding: 3px;
    margin-left: 10px;
    border-radius: 4px;
    display: flex;

    &.active {
      background-color: $background-color;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
